var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from "~/core/decorator";
var CaseOutRecordController = /** @class */ (function () {
    function CaseOutRecordController() {
    }
    /**
     * 下载电催根据模板
     */
    CaseOutRecordController.prototype.downLoadMobileUrge = function () {
        return this.netService.send({
            server: domainService.caseOutRecordController.downLoadMobileUrge,
        });
    };
    /**
     * 下载外访根据模板
     */
    CaseOutRecordController.prototype.downLoadOutVisit = function () {
        return this.netService.send({
            server: domainService.caseOutRecordController.downLoadOutVisit,
        });
    };
    __decorate([
        Inject(NetService)
    ], CaseOutRecordController.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], CaseOutRecordController.prototype, "downLoadMobileUrge", null);
    __decorate([
        Debounce()
    ], CaseOutRecordController.prototype, "downLoadOutVisit", null);
    return CaseOutRecordController;
}());
export { CaseOutRecordController };
